import { Chip } from '@material-ui/core'
import { CheckCircle, Pending } from '@mui/icons-material'
import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'

function InstalacionComponent(props) {
    const i = props.instalacion
    const nombre = props.nombre

    return (
        <Fragment><br />
            <div className='row' style={{ color: 'black' }}>
                <div className={i.informaciongeneralinstalacioncliente.isdictaminada ? 'col-2 alert' : 'col-2 alert alert-primary'} style={i.informaciongeneralinstalacioncliente.isdictaminada ? { backgroundColor: "#DEFFCF" } : {}}>
                    {
                        i.informaciongeneralinstalacioncliente.isdictaminada ?
                            <button className='btn btn-primary' disabled onClick={() => props.handleSetCliente(
                                i.informaciongeneralinstalacioncliente.instalacionnumero,
                                i.idcliente,
                                i.informaciongeneralinstalacioncliente.idiformaciongeneralcliente,
                                i)}
                            >
                                <strong>{nombre}</strong>
                            </button>
                            :
                            <button className='btn btn-primary' onClick={() => props.handleSetCliente(
                                i.informaciongeneralinstalacioncliente.instalacionnumero,
                                i.idcliente,
                                i.informaciongeneralinstalacioncliente.idiformaciongeneralcliente,
                                i)}
                            >
                                <strong>{nombre}</strong>
                            </button>
                    }
                </div>
                <div className={i.informaciongeneralinstalacioncliente.isdictaminada ? 'col-10 alert' : 'col-10 alert alert-primary'} style={i.informaciongeneralinstalacioncliente.isdictaminada ? { backgroundColor: "#DEFFCF", color: 'black' } : { color: 'black' }}>
                    <div className="row">
                        <div className="col">
                            <i><strong>{i.informaciongeneralinstalacioncliente.alias}</strong></i><br />
                        </div>
                        <div className="col">
                            <h5 style={{ textAlign: 'right' }}>{i.informaciongeneralinstalacioncliente.isdictaminada ? <Chip label="Dictaminada" icon={<CheckCircle />} color="primary" /> : <Chip label="Pendiente" icon={<Pending />} color="secondary" />}</h5>
                        </div>
                    </div>
                    <i><strong>Domicilio:</strong> {i.informaciongeneralinstalacioncliente.calle} #{i.informaciongeneralinstalacioncliente.numeroexterior}<br />
                        Colonia:{i.informaciongeneralinstalacioncliente.colonia}
                        <br />{i.informaciongeneralinstalacioncliente.localidad} &nbsp;
                        {i.informaciongeneralinstalacioncliente.municipio} &nbsp;{i.informaciongeneralinstalacioncliente.estado} &nbsp;{i.informaciongeneralinstalacioncliente.codigopostal}
                        <br /> {i.informaciongeneralinstalacioncliente.referenciascercanas}<br /><br />
                        <i><strong>Responsable de Instalaciones:</strong> {i.informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente[0]?.nombreresponsable}</i>
                    </i><br />
                </div>
            </div>
        </Fragment>
    );
};


export default withRouter(InstalacionComponent)
